import * as React from 'react';
import { hydrateRoot } from 'react-dom/client';
import { initGlobals } from './initGlobals.js';

const fetchProps = async () => {
  const response = await fetch('', {
    headers: {
      Accept: 'application/json',
    },
  });
  const props = await response.json();

  return props;
};
const asyncInit = async (App) => {
  let props = {};
  try {
    props = await fetchProps();
  } catch (error) {
    console.error('Could not fetch app props. Hydration aborted', error);
    return;
  }

  initGlobals(props);
  console.warn({ props });
  hydrateRoot(document, <App {...props} />);
};
// No import to AppProps, this may break code slicing, optimisations.
export const init = (App) => {
  asyncInit(App);
};
